import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';

const TooltipWrapper = ({
  className,
  handleMouseOver,
  handleMouseLeave,
  handleClick,
  isOpen,
  tooltipText,
  children,
  tooltipStyle,
  tooltipHelperStyle,
}) => {
  return (
    <div
      className={`${styles.tooltipContainer} ${className}`}
      onClick={handleClick}
      onMouseEnter={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      data-test="tooltip"
    >
      {children}
      {isOpen && tooltipText ? (
        <div
          data-test="tooltipHelper"
          className={tooltipStyle}
          style={tooltipHelperStyle}
        >
          {tooltipText}
        </div>
      ) : null}
    </div>
  );
};

export default enhance(TooltipWrapper);
